import { StateType } from 'data/types'

export const getConnection = (state: StateType) => state.socket
